import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";
import { isEmpty } from "lodash-es";

import { BETTING_LIMIT_ACTION_TYPE } from "./betting-limit.action";
import { BettingLimit, BettingLimitState, BettingLimitStatus } from "./betting-limit.model";

const INITIAL_STATE: BettingLimitState = {};

export function bettingLimitReducer(state = INITIAL_STATE, action: ActionWithPayload): BettingLimitState {
	switch (action.type) {
		case BETTING_LIMIT_ACTION_TYPE.getBetCountLimitSuccess:
		case BETTING_LIMIT_ACTION_TYPE.getBetSizeLimitSuccess:
		case BETTING_LIMIT_ACTION_TYPE.getTimedWageringLimitSuccess:
		case BETTING_LIMIT_ACTION_TYPE.getRemainingBetLimitSuccess:
		case BETTING_LIMIT_ACTION_TYPE.getWageringLimitSuccess: {
			const bettingLimits: BettingLimit[] = action.payload;

			if (bettingLimits.length) {
				const activeBettingLimit = bettingLimits.find((limit) => limit.status === BettingLimitStatus.Active);
				const queuedBettingLimit = bettingLimits.find((limit) => limit.status === BettingLimitStatus.Queued);
				const remainingBetLimits = bettingLimits.filter((limit) => limit.progressValue !== undefined);

				return updateState(state, {
					...(!isEmpty(activeBettingLimit) ? { activeBettingLimit } : {}),
					...(!isEmpty(queuedBettingLimit) ? { queuedBettingLimit } : { queuedBettingLimit: undefined }),
					...(!isEmpty(bettingLimits) ? { bettingLimits } : {}),
					...(!isEmpty(remainingBetLimits) ? { remainingBetLimits } : {}),
				});
			}

			return state;
		}
		case BETTING_LIMIT_ACTION_TYPE.reset:
			return INITIAL_STATE;
		default:
			return state;
	}
}
